module.exports = __webpack_public_path__ + "img/activity.7ab54b9f.svg";